import { Pipe, PipeTransform } from '@angular/core';
import { SessionUserRole } from '../helpers/enums/enums';
import { cleanRecName, extractFilenameFromPath, getFirstLastNameChar, isRecMultiParts } from '../helpers/utils';

@Pipe({
    name: 'formatName'
})
export class formatNamePipe implements PipeTransform {

    constructor() { }
    transform(name: any, action: string = "", data?: any): string {
        let val = '';
        if (name) {
            if (action === 'firstLastName1Char') {
                val = getFirstLastNameChar(name)
            }
            if (action === 'cleanName') {
                const filename = extractFilenameFromPath(name);
                let isMultiPart = isRecMultiParts(filename, data);
                val = cleanRecName(filename, !isMultiPart)
                val = val ? `${val}` : '';
            }
            if (action === 'role') {
                const roleId = +name.split('-role-').pop();
                switch (roleId) {
                    case SessionUserRole.producer:
                        val = 'Producer'
                        break;
                    case SessionUserRole.guest:
                        val = 'Guest'
                        break;
                    case SessionUserRole.audience:
                        val = 'Audience'
                        break;
                }
            }
        }
        return val;
    }
}